module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "storyForm",
    attrs: {
      "model": _vm.storyForm,
      "label-position": _vm.labelPosition,
      "rules": _vm.storyFormRules
    }
  }, [_c('el-form-item', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.QRcodeUrl != '') ? _c('img', {
          staticStyle: {
            "height": "100px",
            "width": "100px",
            "background-image": "background-repeat: no-repeat",
            "background-position": "center center",
            "background-size": "cover"
          },
          attrs: {
            "src": _vm.QRcodeUrl
          },
          on: {
            "click": function($event) {
              _vm.see(_vm.QRcodeUrl)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.storyForm.ImageUrlStr != '') ? _c('img', {
          staticStyle: {
            "height": "100px",
            "width": "100px",
            "background-image": "background-repeat: no-repeat",
            "background-position": "center center",
            "background-size": "cover"
          },
          attrs: {
            "src": _vm.storyForm.ImageUrlStr
          },
          on: {
            "click": function($event) {
              _vm.see(_vm.storyForm.ImageUrlStr)
            }
          }
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "门店名称",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.storyForm.Name),
      callback: function($$v) {
        _vm.$set(_vm.storyForm, "Name", $$v)
      },
      expression: "storyForm.Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "门店负责人",
      "prop": "LinkMan"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.storyForm.LinkMan),
      callback: function($$v) {
        _vm.$set(_vm.storyForm, "LinkMan", $$v)
      },
      expression: "storyForm.LinkMan"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "负责人电话",
      "prop": "Mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.storyForm.Mobile),
      callback: function($$v) {
        _vm.$set(_vm.storyForm, "Mobile", $$v)
      },
      expression: "storyForm.Mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "门店电话"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.storyForm.Tel),
      callback: function($$v) {
        _vm.$set(_vm.storyForm, "Tel", $$v)
      },
      expression: "storyForm.Tel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.storyForm.Address),
      callback: function($$v) {
        _vm.$set(_vm.storyForm, "Address", $$v)
      },
      expression: "storyForm.Address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.Download($event)
      }
    }
  }, [_vm._v("下载分享二维码")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.imageShow()
      }
    }
  }, [_vm._v("上传门店印章")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看大图"
    },
    model: {
      value: (_vm.seeImageVisible),
      callback: function($$v) {
        _vm.seeImageVisible = $$v
      },
      expression: "seeImageVisible"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "margin": "0 auto",
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "background-image": "background-repeat: no-repeat",
      "background-position": "center center",
      "background-size": "cover"
    },
    attrs: {
      "src": _vm.imgUrl
    }
  })])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "id": "tt",
      "title": "上传"
    },
    model: {
      value: (_vm.uploadimageVisible),
      callback: function($$v) {
        _vm.uploadimageVisible = $$v
      },
      expression: "uploadimageVisible"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": "",
      "http-request": _vm.upload,
      "multiple": "",
      "customClass": ".el-upload-dragger"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传jpg/png文件，且不超过500kb")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c195d98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ShopManagement/ShopInfo.vue
// module id = 1348
// module chunks = 1